// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { useTimeline } from '@/contexts/timeline-context';

interface Props {
  x: number;
  y: number;
  width: number;
  height: number;
}

export function TimelineFocusIndicator(props: Props) {
  const { palette } = useTimeline();

  return (
    <rect
      x={props.x}
      y={props.y}
      width={props.width}
      height={props.height}
      fill={palette.focus.solid}
    />
  );
}
